import React from 'react';

/**
 * 로딩 스켈레톤 프리미티브.
 * "빈 화면 → 갑자기 채워짐" 대신 자리를 먼저 잡아 레이아웃 점프와 '데이터가 없다'는 오해를 막는다.
 * 애니메이션은 Tailwind `animate-pulse`(index.css의 reduced-motion 블록이 정지시킨다).
 */
export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  // rounded-*가 className에 있으면 기본 rounded-md를 빼서 유틸 충돌(원형이 사각으로)을 피한다
  <div aria-hidden="true" className={`animate-pulse bg-slate-200 ${/rounded/.test(className) ? '' : 'rounded-md'} ${className}`} />
);

/** 대화방 목록/최근 대화 행 모양 (아바타 + 2줄) */
export const ChannelListSkeleton: React.FC<{ rows?: number; size?: 'md' | 'lg' }> = ({ rows = 5, size = 'lg' }) => {
  const avatar = size === 'lg' ? 'w-12 h-12' : 'w-10 h-10';
  return (
    <div role="status" aria-label="불러오는 중" className="divide-y divide-slate-100">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3">
          <Skeleton className={`${avatar} rounded-full shrink-0`} />
          <div className="flex-1 min-w-0 space-y-2">
            <div className="flex justify-between">
              <Skeleton className="h-3.5 w-28" />
              <Skeleton className="h-3 w-12" />
            </div>
            <Skeleton className="h-3 w-3/4" />
          </div>
        </div>
      ))}
    </div>
  );
};

/** 관리자 표 모양 (행 × 열) */
export const TableSkeleton: React.FC<{ rows?: number; cols?: number }> = ({ rows = 5, cols = 3 }) => (
  <div role="status" aria-label="불러오는 중" className="space-y-2 py-2">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-3 px-3 py-2.5 rounded-lg border border-slate-100 bg-white">
        {Array.from({ length: cols }).map((__, c) => (
          <Skeleton key={c} className={`h-3.5 ${c === 0 ? 'w-40' : c === cols - 1 ? 'w-16 ml-auto' : 'w-24'}`} />
        ))}
      </div>
    ))}
  </div>
);
